import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const AvailabilityDropdown = ({ user }) => {
	const handleSetAvailable = (event) => {
		event.preventDefault();
		user.set('available_ind', true);
		user.save();
	};

	const handleSetUnavailable = (event) => {
		event.preventDefault();
		user.set('available_ind', false);
		user.save();
	};

	const available = Boolean(user.get('available_ind'));

	return (
		<li className="dropdown" style={{ height: '50px' }}>
			<button
				className={cn('availability', 'btn', 'dropdown-toggle', 'mh-lg', 'mv', {
					'btn-success': available,
					'btn-danger': !available,
				})}
				type="button"
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="true"
			>
				<span className="lbl">
					{available ? 'Available (On-demand)' : 'Unavailable'}{' '}
				</span>
				<span className="caret"></span>
			</button>
			<ul className="dropdown-menu">
				<li>
					<a href="#" className="available" onClick={handleSetAvailable}>
						Available (On-demand)
					</a>
				</li>
				<li>
					<a href="#" className="unavailable" onClick={handleSetUnavailable}>
						Unavailable
					</a>
				</li>
			</ul>
		</li>
	);
};

AvailabilityDropdown.propTypes = {
	user: PropTypes.object.isRequired,
};

export default AvailabilityDropdown;
